import React, { useState, useEffect } from 'react';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { updateDoc, collection, doc, getDoc } from "firebase/firestore";
import { getDb } from "../../util/Constants";

function EditMiscellaneous(props) {
    const [misName, setMisName] = useState("");
    const [misValue, setMisValue] = useState("");
    const [load, setLoad] = useState(false);


    useEffect(() => {
        fetchData()
    }, [props.modal])
    const fetchData = async () => {
        setMisName(props?.item?.characterName);
        setMisValue(props?.item?.characterValue);
    }

    const handleSubmit = async (e) => {

        e.preventDefault();
        setLoad(true);
        const docRef = doc(getDb(), "util", "meta");
        // let dataCapital = difficulty.charAt(0).toUpperCase() + difficulty.slice(1)
        await updateDoc(docRef, {
            miscellaneous: {
                ...props.Obj, [misName]: misValue
            }
        });
        props.getOptions();
        setLoad(false);
        props.toggle();

    };


    return (
        <div>
            <Modal isOpen={props.modal} toggle={props.toggle}>
                <ModalHeader toggle={props.toggle}>Edit Characters</ModalHeader>
                <ModalBody style={{ paddingTop: "10px" }}>
                    <Form onSubmit={handleSubmit}>
                        <div className="">

                            <FormGroup>
                                <Label >
                                    Character
                                </Label>
                                <Input
                                    type="text"
                                    id="mis"
                                    maxLength="250"
                                    value={misName}
                                    disabled
                                    required
                                    className="form-control-alternative"
                                    onChange={(e) => setMisName(e.target.value)}
                                />

                            </FormGroup>
                            <FormGroup>
                                <Label for="mis">
                                    Name
                                </Label>
                                <Input
                                    type="text"
                                    value={misValue}
                                    required
                                    className="form-control-alternative"
                                    onChange={(e) => setMisValue(e.target.value)}
                                />

                            </FormGroup>
                        </div>
                        <Button color="primary" type={"submit"} disabled={load}>
                            {load ? (
                                <Spinner color="light" size="sm" />
                            ) : (
                                "Save"
                            )}
                        </Button>
                        <Button color="secondary" onClick={props.toggle}>
                            Cancel
                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default EditMiscellaneous;